/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, {
  useRef, useMemo, useCallback, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import Tags from '@yaireo/tagify/dist/react.tagify'; // ✅ React wrapper
import '@yaireo/tagify/dist/tagify.css'; // ✅ Required styling

import { getIdMap } from '../../../helpers/helpers';

import {
  mapV1FormulaToV2,
  cleanTagValue,
  convertTagifyTagsToOntraccrTags,
} from './tagInput.helpers';

function TagInput({
  id,
  calculationColumn,
  sections,
  fieldMap,
  formula,
  tags,
  onTagsAndFormulaChange,
  whitelist = [],
}) {
  const tagifyRef = useRef();

  const settings = useMemo(() => ({
    mode: 'mix',
    pattern: /#/,
    tagTextProp: 'value',
    enforceWhitelist: true,
    duplicates: true,
    dropdown: {
      enabled: 0,
      position: 'input',
      mapValueTo: 'value',
      maxItems: Infinity,
      includeSelectedTags: true,
    },
    whitelist,
  }), [whitelist]);

  const sectionMap = useMemo(() => getIdMap(sections), [sections]);

  const initialValue = useMemo(() => (
    mapV1FormulaToV2({
      formula,
      tags,
      fieldMap,
      sectionMap,
      calculationColumn,
      id,
    })
  ), [formula, tags, fieldMap, calculationColumn, id]);

  const handleChange = useCallback((e) => {
    if (!e?.detail?.tagify) return;
    const stringValue = cleanTagValue(e.detail.tagify.getInputValue());
    const tagList = e.detail.tagify.getCleanValue();
    onTagsAndFormulaChange(convertTagifyTagsToOntraccrTags({
      tags: tagList,
      value: stringValue,
      fieldMap,
    }));
  }, [fieldMap, onTagsAndFormulaChange]);

  useEffect(() => {
    const tagify = tagifyRef.current;
    if (!tagify) return;

    const moveCaretToEnd = () => {
      const editable = tagify.DOM.input;
      const range = document.createRange();
      const sel = window.getSelection();
      range.selectNodeContents(editable);
      range.collapse(false); // move to end
      sel.removeAllRanges();
      sel.addRange(range);
    };

    tagify.on('dropdown:select', () => {
      setTimeout(moveCaretToEnd, 10);
    });
  }, []);

  return (
    <Tags
      tagifyRef={tagifyRef}
      settings={settings}
      value={initialValue}
      defaultValue=""
      onChange={handleChange}
      onAdd={handleChange}
      style={{ '--tagify-dd-width': '800px' }}
    />
  );
}

TagInput.propTypes = {
  sections: PropTypes.array.isRequired,
  fieldMap: PropTypes.object.isRequired,
  formula: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  calculationColumn: PropTypes.string,
  onTagsAndFormulaChange: PropTypes.func.isRequired,
  whitelist: PropTypes.array,
};

TagInput.defaultProps = {
  whitelist: [],
};

export default TagInput;
